import { z } from "zod";

// PG-002 (resolución humana 2026-09-07): el avance inicial por excedente es
// opcional, entero entre 0 y el excedente real que solo el llamador conoce
// (compras que sustentan el conteo por encima de la meta) — de ahí la
// fábrica en vez de un esquema fijo. El motivo es obligatorio únicamente
// cuando el avance inicial declarado es mayor que cero (`REASON_REQUIRED`,
// SPEC-209 §8).
export function makeDeliveryFormSchema(maxSurplus: number) {
  return z
    .object({
      confirmed: z.boolean(),
      initialProgress: z.coerce
        .number()
        .int("El avance inicial debe ser un número entero")
        .min(0, "El avance inicial no puede ser negativo")
        .max(
          maxSurplus,
          `El avance inicial no puede superar el excedente (${maxSurplus})`,
        )
        .optional(),
      reason: z.string().optional(),
    })
    .superRefine((value, ctx) => {
      if (!value.confirmed) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["confirmed"],
          message: "Confirma la entrega del gran premio",
        });
      }
      if ((value.initialProgress ?? 0) > 0 && !(value.reason ?? "").trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["reason"],
          message: "Indica el motivo del avance inicial reconocido",
        });
      }
    });
}
export type DeliveryFormValues = {
  confirmed: boolean;
  initialProgress?: number | undefined;
  reason?: string | undefined;
};
